import { getTestIds } from 'seagull/utils/TestIds';
export const GetImportAgreementModalTID = (parentTestId)=>getTestIds(parentTestId);
export const STEP_INTERVAL_MS = 4000;
export const SUCCESS_DELAY_MS = 500;
export const MAX_FILE_SIZE_MB = 20;
export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;
